import { TransactionType } from './transactionType'

/**
 * As of 11/6/2025, we have two product labels:
 * - Bridge Loan Plus (only for HSEA3 transactions)
 * - Bridge Loan (for all other transactions)
 *
 * @param transactionType - The transaction type to get the product label for
 * @returns The product label for the given transaction type
 */
export const getProductLabel = (transactionType?: TransactionType) => {
  if (transactionType === TransactionType.HSEA3 || transactionType === TransactionType.HSEA3_MORTGAGE_BROKER) {
    return 'Bridge Loan Plus'
  }

  return 'Bridge Loan'
}
